<!-- ion-nav removido: renderiza o componente `root` dinamicamente (login/register/etc.). -->
<ng-container #host></ng-container>
